import { Component } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ImageLazyLoadingDirective } from '../../../directives/img-lazy-loading.directive';
import { routes } from '../../../constants/routes';
import { socialLinks } from '../../../constants/social-links';
import { ApiService } from '../../../services/api.service';
import { Subject, takeUntil } from 'rxjs';
import { DecimalPipe } from '@angular/common';
import { environment } from '../../../../environments/environment';
import { UtilityService } from '../../../services/utility.service';
import { SuggestIdeaComponent } from '../../utility/suggest-idea/suggest-idea.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink, ImageLazyLoadingDirective, DecimalPipe, SuggestIdeaComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  routes = routes;
  readonly socialLinks = socialLinks;
  public currentYear = 2025;
  public visitorCount: number = 0;
  private destroy$ = new Subject<boolean>();

  constructor(
    private router: Router,
    private apiService: ApiService,
    protected utilityService: UtilityService,
  ) {}

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.updateVisitorCount();
    this.getVisitorCount();
  }

  onGetStartedClick() {
    const url = `${environment.webUrl}${environment.webBaseHref}dashboard`;
    this.utilityService.openExternalPage(url);
  }

  getVisitorCount() {
    this.apiService
      .getVisitorCount()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        this.visitorCount = res.visitors;
      });
  }

  updateVisitorCount() {
    this.apiService
      .updateVisitorCount()
      .pipe(takeUntil(this.destroy$))
      .subscribe((res) => {});
  }

  redirectToIndiaAI() {
    window.open('https://indiaai.gov.in/', '_blank');
  }

  ngOnDestroy() {
    this.destroy$.next(true);
  }
}
